
/**
 *
 *      Data-driven UI logic for global page state
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 06/14/2017
 *      Modified on 04/22/2019
 */


/**
 * Construct a global state object based on the JSON model of the page state
 * @param pageName {string} - name of the page
 * @param type {string} - data type
 * @returns {*}
 */
function getPageState( pageName, type ) {
    var pageState = null,
        collection,
        json;

    if ( type ) {
        json = getJSONModel( "page", type, null );
        if ( json ) {
            collection = getBackboneCollection( json.properties );
        }
    }
    if ( collection ) {
        _.each( collection.models, function( model ) {
            if ( model.get("page") === pageName ) {
                pageState = model.get( "regions" );
            }
        });
    }
    return pageState;
}

/**
 * Get region page state variables
 * @param regionName {string} - region name
 * @returns {*}
 */
function getRegionVariables( regionName ) {
    var j,
        globalState,
        result = null;
   if ( GlobalPageState && regionName ) {
       for ( j = 0; j < GlobalPageState.length; j++ ) {
           globalState = GlobalPageState[j];
           if ( globalState && globalState.name === regionName ) {
               return globalState.variables;
           }
       }
   }

   return result;
}

/**
 * Update global page state object
 * @param regionName {string} - region name
 * @param data {object} - JavaScript object containing new page state information
 */
function updateGlobalPageState(regionName, data) {
    var i,
        j,
        globalState,
        variables,
        variableName,
        newValue,
        success = false;
    if (data) {
        for (j = 0; j < GlobalPageState.length; j++) {
            globalState = GlobalPageState[j];
            if (globalState && globalState.name === regionName) {
                variables = globalState.variables;
                for (i = 0; i < variables.length; i++) {
                    // update global variables
                    variableName = variables[i].name;
                    if (variableName) {
                        newValue = data[variableName];
                        if (newValue) {
                            variables[i].value = newValue;
                            success = true;
                        }
                    }
                }
            }
        }
    }
    return success;
}

/**
 * Get an object that contains graph side state variables (TODO: get the name of those variables from the "side" attribute in the view JSON model)
 * @param data {object} - record data
 * @param total {number} - total number of records
 * @param page {number} - current page number
 * @returns {Array}
 */
function getSideState(data, total, page) {
    var dataObj = [];
    dataObj.push( { "name": "data", "value": data } );
    if ( data ) {
        dataObj.push( { "name": "total", "value": total } );
        dataObj.push({ "name": "page", "value": page } );
    }
    return dataObj;
}

/**
 * Construct an object that holds graph data for each side
 * @param display {object} - JavaScript object model for graph display
 * @param data {object} - data object to graph
 * @param pageObj {object} - page number object
 * @returns {{}}
 */
function getSideDataObject( display, data, pageObj ) {
    var displayData = {},
        sideDataObj = {},
        id,
        side,
        sideStateArray,
        node,
        current,
        page,
        i,
        k;

    if ( GlobalPageState && display && data ) {
        for (i = 0; i < display.length; i++) {
            displayData[ display[i].side ] = data[ display[i].data ];
            sideDataObj[ display[i].side ] = {};
        }

        // Get non-nested node data first
        for ( i = 0; i < display.length; i++ ) {
            for ( side in sideDataObj ) {
                if ( sideDataObj.hasOwnProperty( side ) ) {
                    if ( side === display[i].side && ! ( display[ i ].nested && display[ i ].nested === "true" ) ) {
                        page = pageObj[ side ];
                        if ( page ) {
                            sideStateArray = getSideState( getResponseObject( displayData[side] ), getNumberOfHits( displayData[side] ), page );
                            if ( sideStateArray ) {
                                sideDataObj[side] = sideStateArray;
                            }
                        }

                    }
                }
            }
        }
        // Nested node data
        id = GlobalPageState.id;
        for ( i = 0; i < display.length; i++ ) {
            for ( side in sideDataObj ) {
                if ( sideDataObj.hasOwnProperty( side ) ) {
                    if ( side === display[ i ].side && display[ i ].nested && display[ i ].nested === "true" ) {
                        var nestedDataObj = getResponseObject( displayData[ side ] );
                        if ( nestedDataObj ) {
                            for ( k = 0; k < nestedDataObj.length; k++ ) {
                                node = {};
                                node.ediId = nestedDataObj[ k ][ "_id" ];
                                current = getDataField( nestedDataObj[ k ], "_source" );
                                if ( node.ediId === id && current ) {
                                    page = pageObj[ side ];
                                    if ( page ) {
                                        sideStateArray = getSideState( current["bill"], current["bill"].length, page );
                                        if ( sideStateArray ) {
                                            sideDataObj[side] = sideStateArray;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return sideDataObj;
}

/**
 * Update global page state object
 * @param regionId {string} - region id
 * @param data {object} - JavaScript object containing new page state information
 */
function updateGlobalPageStateById(regionId, data) {
    var success = false,
        regionName = getRegionNameById(regionId);
    if (regionName) {
        success = updateGlobalPageState(regionName, data);
    }
    return success;
}

/**
 * Initialize global page state
 * @param pageName {string} - name of the page
 * @param type {string} - data type
 * @returns {object} - page state before any state changes take place
 */
function initialGlobalPageState( pageName, type ) {

    var state,
        variables,
        i,
        j;

    state = getPageState( pageName, type );
    if ( state ) {
        for ( i = 0; i < state.length; i++ ) {
            variables = state[i].variables;
            if ( variables ) {
                for ( j = 0; j < variables.length; j++ ) {
                    variables[j].value = variables[j].default;
                }
            }
        }
    }
    return state;
}

/**
 * Save current record settings into global page state variable.
 * @param alias {string} Record alias.
 * @param type {string} Record type (index).
 * @param id {string} Record EDI id.
 * @param viewtype {*} Record view type (i.e. "cdm", "ui", etc.).
 * @param version {*} Record EDI iteration (optional).
 */
function setGlobalPageState( alias, type, id, viewtype, version ) {

    if ( ! GlobalPageState ) {
        GlobalPageState = {};
    }

    // Store record parameters into the global state

    GlobalPageState.type = type;
    GlobalPageState.id = id;
    GlobalPageState.alias = alias;
    GlobalPageState.viewtype = viewtype;
    GlobalPageState.version = version;

}

/**
 * Get current record settings global page state variable.
 */
function getGlobalPageState( ) {

    if ( ! GlobalPageState ) {
        GlobalPageState = {};
    }

    return GlobalPageState;

}